module.exports = __webpack_public_path__ + "static/media/news.82d93197.svg";